<div class="search" data-testid="search-container">
  <div class="map-search" [ngClass]="{'failedPlan': failedPlan}"
    [attr.data-tutorial-target]="!routeIcon && !addressSearch ? 'search' : null">
    @if (routeIcon && routeIcon!='waypoint' && routeIcon!='empty') {
      <div class="route-icon" [ngClass]="{'route-charge-icon': csid}"
        >
        <img [src]="routeIcon" alt="route" />
        @if (waypointIdx) {
          <div class="waypoint-charge-here-number">{{ waypointIdx }}</div>
        }
      </div>
    }
    @if (routeIcon && routeIcon=='waypoint') {
      <div class="route-icon">
        <div class="waypoint-circle"> {{ waypointIdx }} </div>
        @if (batteryReservedWarning) {
          <div class="battery-reserved-warning-icon">!</div>
        }
      </div>
    }
    @if (routeIcon && routeIcon=='empty') {
      <div class="route-icon">
        <div class="waypoint-circle"></div>
      </div>
    }
    <input autocomplete="off" type="text" #searchInput data-testid="search-input"
      [placeholder]="languageService.languageJSON.InfoSidebar_SearchOnMap" [(ngModel)]="inputValue"
      [ngClass]="{'search-with-route': routeIcon}" (keyup.enter)="onSearchSubmit(searchInput.value)"
      (keyup)="searchInputChanged(searchInput.value)" (click)="searchActivated()" (focus)="searchFocused()">
      @if (!routeIcon && !addressSearch) {
        <button type="button" class="ev-plain-button search-image" data-testid="search-submit-btn" (click)="onSearchSubmit(searchInput.value)"></button>
      }
    </div>
    @if (searchActive()) {
      <div class="search-dropdown" data-testid="search-dropdown-container" data-tutorial-avoid>
        @if (displayedSearchResults().length>0) {
          <span>
            @for (searchEl of displayedSearchResults(); track searchEl) {
              <button type="button" class="ev-plain-button search-dropdown-item"
                [attr.data-testid]="'search-result-item-' + $index"
                (click)="searchElementSelected(searchEl)">
                <span class="search-result-text">
                  @for (seg of getTextSegments(searchEl); track $index) {
                    <span [class.highlight]="seg.highlighted">{{ seg.text }}</span>
                  }
                </span>
              </button>
            }
          </span>
        }
        @if (displayedSearchResults().length==0) {
          <span>
            @if (showHomeWork) {
              <button type="button" class="ev-plain-button search-dropdown-item shortcut-item" data-testid="search-home-shortcut-btn" (click)="homeShortcutSelected()">
                <img class="shortcut-icon" src="assets/icons/dark/ui/home_icon.svg" alt="home" />
                <span class="shortcut-text">
                  <span class="shortcut-title">{{ languageService.languageJSON.SettingsDialog_Home }}</span>
                  @if (homeAddressDescription) {
                    <span class="shortcut-address">{{ homeAddressDescription }}</span>
                  }
                </span>
              </button>
              <button type="button" class="ev-plain-button search-dropdown-item shortcut-item" data-testid="search-work-shortcut-btn" (click)="workShortcutSelected()">
                <img class="shortcut-icon" src="assets/icons/dark/ui/work_icon.svg" alt="work" />
                <span class="shortcut-text">
                  <span class="shortcut-title">{{ languageService.languageJSON.SettingsDialog_Work }}</span>
                  @if (workAddressDescription) {
                    <span class="shortcut-address">{{ workAddressDescription }}</span>
                  }
                </span>
              </button>
            }
            @if (showHomeWork && searchHistory().length>0) {
              <div class="search-dropdown-divider"></div>
            }
            @for (searchEl of searchHistory(); track searchEl) {
              <button type="button" class="ev-plain-button search-dropdown-item history-item"
                [attr.data-testid]="'search-history-item-' + $index"
                (click)="searchHistoryElementSelected(searchEl)">
                <img class="shortcut-icon" src="assets/icons/default/ui/search_history_icon.svg" alt="history" />
                <span class="history-name">{{ searchEl.display_name }}</span>
              </button>
            }
          </span>
        }
        <div class="google-attribution">
          <img src="assets/icons/default/ui/powered_by_google_on_non_white.png" alt="google" />
        </div>
      </div>
    }
    <div id="attributions"></div>
  </div>